import { Log, UserManager, WebStorageStateStore } from 'oidc-client-ts'
import store from '../../store.js'
import server from '../api/server.js'

class Auth {
  constructor(oidcConfig) {
    /* //This helps to debug UserManager issues
    Log.logger = console
    Log.level = Log.INFO */
    const url = window.location.origin
    this.userManager = new UserManager({
      authority: oidcConfig.issuer,
      client_id: oidcConfig.clientId,
      client_secret: oidcConfig.clientSecret,
      redirect_uri: `${url}/login-callback`,
      silent_redirect_uri: `${url}/login-callback-silent.html`,
      post_logout_redirect_uri: `${url}`,
      response_type: 'code',
      scope: oidcConfig.scope,
      prompt: oidcConfig.prompt,
      extraQueryParams: oidcConfig.extraQueryParams,
      monitorSession: false,
      userStore: new WebStorageStateStore({ store: window.localStorage })
    })

    this.userManager.metadataService.getEndSessionEndpoint().then(url => { this.canEndSession = !!url })
    this.userManager.clearStaleState()
  }

  async getUser() {
    const user = await this.userManager.getUser()
    return user
  }

  async login(state) {
    await this.userManager.signinRedirect({
      state,
      useReplaceToNavigate: true
    })
  }

  async handleLoginCallback() {
    const user = await this.userManager.signinRedirectCallback()
    return user.state
  }

  async logout(logoutFromRSSPToo = true) {
    if (this.canEndSession) {
      let params
      if (logoutFromRSSPToo) {
        const rsspPublicUrl = store.state.remoteConfig !== null ? store.state.remoteConfig.rsspPublicUrl : ''
        params = { post_logout_redirect_uri: rsspPublicUrl + 'logoutOnlySelf' }
      }
      await this.userManager.signoutRedirect(params)
    } else {
      await this.userManager.removeUser()
      if (logoutFromRSSPToo) {
        const rsspPublicUrl = store.state.remoteConfig !== null ? store.state.remoteConfig.rsspPublicUrl : ''
        location.href = rsspPublicUrl + 'logoutOnlySelf'
      }
    }
    // store.commit('removeCurrentUser') //addUserUnloaded elvileg meghívja
  }

  async logoutOnlySelf() {
    await this.userManager.removeUser()
  }

  async getAccessToken(forceRefresh = false) {
    const user = await this._getRefreshingUser(forceRefresh)
    return user.access_token
  }

  async getIdToken(forceRefresh = false) {
    const user = await this._getRefreshingUser(forceRefresh)
    return user.id_token
  }

  addUserLoaded(func) {
    this.userManager.events.addUserLoaded(func)
  }

  addUserUnloaded(func) {
    this.userManager.events.addUserUnloaded(func)
  }

  async _getRefreshingUser(forceRefresh = false) {
    let user = await this.userManager.getUser()
    if (forceRefresh || !user || user.expired) {
      try {
        user = await this.userManager.signinSilent()
      } catch (error) {
        await this.userManager.removeUser()
        throw error
      }
    }

    return user
  }
}

async function createAuth() {
  const resp = await server.getOidcConfig('web')
  return new Auth(resp)
}

export default createAuth
